import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { observer } from 'mobx-react-lite'
import useStore from '@/hooks/useStore.js'
import Icon from '@mdi/react'
import { mdiAccountAlertOutline } from '@mdi/js'
import { Button } from '@/components/ui/button.jsx'

const Authenticated = () => {
  const { authStore, routerStore } = useStore()

  if (authStore.isLoggedIn) return <Outlet />

  return (
    <div className="flex grow flex-col items-center justify-center gap-6 p-3">
      <Icon className="max-h-fit w-full max-w-32" path={mdiAccountAlertOutline} size="100%" />

      <div className="text-center">
        <h1 className="text-2xl">You are not signed in</h1>
        <h2 className="mt-2 text-lg">Please sign in to continue</h2>
      </div>

      <div className="flex flex-wrap justify-center gap-3">
        <Button className="grow" onClick={authStore.login}>
          Sign in
        </Button>

        <Button asChild className="grow" variant="outline">
          <Link to={routerStore.routes.index}>Go Home</Link>
        </Button>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated')({
  component: observer(Authenticated),
})
